import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@shopify/polaris'
import styled from 'styled-components'
import { SHOPIFY_BLUE } from 'components/styles'

const ButtonContainer = styled.div`
  & > button {
    ${props => props.active ? `border: 2px ${SHOPIFY_BLUE} solid !important;` : ''};

  }

  &:hover {
    & > button {
      ${props => props.active ? `border: 2px ${SHOPIFY_BLUE} solid;` : ''};

    }
  }
`

const MenuButton = (props) => (
  <ButtonContainer active={props.active}>
    <Button {...props}>{props.children}</Button>
  </ButtonContainer>

)

MenuButton.propTypes = {
  active: PropTypes.bool
}

export default MenuButton



// WEBPACK FOOTER //
// ./src/components/shopifyApp/shopifyWizard/shopifyOverlay/MenuButton.js